import axios from "axios";

const url = "http://redbrickssss.herokuapp.com";

export const getAllPosts = async () => {
  try {
    let response = await axios.get(`${url}/posts`);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error while Calling getAllPost API ", error);
  }
};
